import React, { Component } from 'react';

import { ReactComponent as ContentListEmptyImage } from 'components/svg/icons/content-list-empty-image.svg';
import { inject } from 'mobx-react';
import PropTypes from 'prop-types';

import { Finished } from '../finished';
import OnboardingChecklist from '../onboardingChecklist/OnboardingChecklist';
import {
  Step,
  getTipStepLabelOnlineEvent
} from '../onboardingChecklist/settings';
import StepTip from '../StepTip';

import './styles.scss';

@inject((stores) => ({
  checkList: stores.ContentOnboardingStore.checkList,
  isOnlineEvent: stores.MembershipStore.onlineEvent
}))
class CardOnboarding extends Component {
  static propTypes = {
    checkList: PropTypes.shape({
      hasModule: PropTypes.bool,
      hasContent: PropTypes.bool,
      publishedContent: PropTypes.bool
    }),
    isOnlineEvent: PropTypes.bool
  };

  static defaultProps = {
    isOnlineEvent: false
  };

  getStep() {
    const { checkList } = this.props;

    if (!checkList.hasModule) {
      return Step.MODULE;
    } else if (!checkList.hasContent) {
      return Step.CONTENT;
    }

    return Step.PUBLISH;
  }

  isNeeddedInvertContentColumn() {
    const { checkList } = this.props;

    return checkList.publishedContent;
  }

  renderContent() {
    const { checkList } = this.props;

    if (
      checkList.hasModule &&
      checkList.hasContent &&
      checkList.publishedContent
    ) {
      return <Finished />;
    }

    return <OnboardingChecklist currentStep={this.getStep()} />;
  }

  renderStepTip() {
    const { isOnlineEvent } = this.props;
    const label = getTipStepLabelOnlineEvent(this.getStep());

    if (isOnlineEvent && label) {
      return <StepTip contentLabel={label} />;
    }
  }

  render() {
    return (
      <>
        <div className="card-onboarding">
          <div className="card-onboarding__content">{this.renderContent()}</div>
          <ContentListEmptyImage />
        </div>
        {this.renderStepTip()}
      </>
    );
  }
}

export default CardOnboarding;
